import React from 'react';
import { ComponentFrame } from "../../frame/ComponentFrame";
import { SectionHeader } from "../../components/section-header/SectionHeader";
import { ItemGroup } from "../../components/item-group/ItemGroup";
import { GridLayout } from "../../components/layout/GridLayout";
import {ContactCardItem} from "../../components/item/ContactCardItem";


export class PersonnelContact extends React.Component {

  render(){
    if(!this.props.contacts)
      return null;
    console.log(this.props.contacts);

    return (
      <div className={"contact-personnel-container"}>
        <ComponentFrame tag="section"
                        header={
                          <SectionHeader align="center"
                                         color="transparent"
                                         title="CONTACT PERSONNEL" />
                        }>
          <ItemGroup layout={ GridLayout }
                     layoutAttributes={{ center: true }}
                     item={ ContactCardItem }
                     itemStyle="" data={this.props.contacts}/>
          <div className="mt-5" style={{ textAlign: "center" }}><strong>Obelux email</strong><br/>firstname.lastname@obelux.com</div>
        </ComponentFrame>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/contact-us/PersonnelContact.js